import { ambienteAplicacion } from 'constants/urls';
import { Hogar } from './constantes/general';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URLS_PHP_7 } from 'constants/urls_v2';

export const onEnviarCorreo = async (data) => {
  const Data = {
    prodCodigo: Hogar.codProducto,
    prodCodigoCore: Hogar.prodCodigoCore,
    proTipoPlan: Hogar.proTipoPlan,
    ambiente: ambienteAplicacion,
    pasoCodigo: 'enviarCorreoCotizacion',

    items: {
      cotCodigo: data.idCotizacion,
      correo: data.correo,
    },
  };

  return await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);
};
